import React from 'react';
import { Modal } from 'react-bootstrap';
import AddEditCityContactsForm from './AddEditCityContactsForm';

const AddEditCityContactModal = ({
  show,
  onHide,
  mode = 'add',
  activeTab,
  initialValues = {},
  onSubmit,
  loading = false,
  entityName = 'Contact',
  style
}) => (
  <Modal show={show} onHide={onHide} style={style} centered backdrop="static">
    <Modal.Header closeButton={!loading}>
      <Modal.Title>
        {mode === 'edit' ? `Update ${entityName}` : `Add ${entityName}`}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="overflow-auto px-3 py-2">
      {show ? (
        <AddEditCityContactsForm
          activeTab={activeTab}
          type={mode}
          initialValues={initialValues}
          onSubmit={onSubmit}
          loading={loading}
        />
      ) : null}
    </Modal.Body>
  </Modal>
);

export default AddEditCityContactModal;
